import React, { useEffect, useState, useCallback } from 'react';
import cn from 'classnames';
import { observer, calculatorState as store } from 'store';
import CountBox from '../CountBox/CountBox';
import MobileSectionModal from './MobileSectionModal';
import CollapseEl from 'components/UI/CollapseEl';
import Icon from 'components/UI/Icon';
import { useStateModal } from 'utils/hooks';
import { getTotal } from '../../utils';
import { useTrans } from 'utils/localisation';
import * as styles from './MobileSection.module.scss';

function MobileSection({
  calculatorID,
  blockType,
  type,
  totalBoxType,
  mobileTitles,
  accordion,
  name: sectionName,
  counterType,
  items,
  defaultValue,
  subtitleMobile,
  options,
  initialStep,
}) {
  const t = useTrans(['common']);
  const { getSectionTotal, getSectionInfo } = store;
  const { modalState, showModal, hideModal } = useStateModal();
  const [collapse, setCollapse] = useState(false);
  const sectionTotal = getSectionTotal(calculatorID, sectionName);
  const sectionInfo = getSectionInfo(calculatorID, sectionName);
  const total = getTotal(sectionInfo, totalBoxType);
  const isEmptyTotal = !total;

  useEffect(() => setCollapse(Boolean(sectionTotal)), [sectionTotal]);

  const showListHandler = useCallback(() => setCollapse(true), []);
  const toggleListHandler = useCallback(() => setCollapse(!collapse), [collapse]);

  return (
    <>
      <button
        className={cn(
          styles.tab,
          isEmptyTotal && styles.plus,
          !isEmptyTotal && accordion && styles.arrow,
          isEmptyTotal && styles.plus,
          collapse && styles.show,
        )}
        onClick={sectionTotal && accordion ? toggleListHandler : showModal}
      >
        {!total && mobileTitles.default}
        {Boolean(total) && <span className={styles.sectionTitle}>{mobileTitles.active}</span>}
        {Boolean(total) && <CountBox total={total} />}
      </button>
      {!isEmptyTotal && accordion && (
        <CollapseEl toggle={collapse}>
          <ul className={styles.list}>
            {Object.entries(sectionInfo).map(([name, value]) => {
              return (
                Boolean(value) && (
                  <li key={name} className={styles.item}>
                    <span className={styles.name}>{name}</span>
                    {counterType === 'counter' && <span className={styles.count}>{value}</span>}
                  </li>
                )
              );
            })}
          </ul>
          <button className={styles.editButton} onClick={showModal}>
            <Icon name="pen-2" className={styles.icon} />
            {t('edit')}
          </button>
        </CollapseEl>
      )}
      <MobileSectionModal
        type={type}
        isOpen={modalState.isOpen}
        blockType={blockType}
        calculatorID={calculatorID}
        sectionName={sectionName}
        totalBoxType={totalBoxType}
        counterType={counterType}
        title={mobileTitles.section}
        subtitleMobile={subtitleMobile}
        items={items}
        defaultValue={defaultValue}
        options={options}
        initialStep={initialStep}
        onClose={hideModal}
        onShowList={showListHandler}
      />
    </>
  );
}

export default observer(MobileSection);
